module.exports = __webpack_public_path__ + "static/media/cloud-moon-rain.ab66e55f.svg";